import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-heart-fill text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-heading font-semibold text-foreground-900">
                爱情岛论坛
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              亚洲最热情感交流社区，汇聚海量恋爱经验分享、婚恋话题讨论与情感咨询资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/lianai-jiqiao" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/lianai-jiqiao" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">恋爱技巧</Link>
              <Link to="/category/hunyuan-huati" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">婚恋话题</Link>
              <Link to="/category/qinggan-zixun" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">情感咨询</Link>
              <Link to="/category/yuehui-gushi" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">约会故事</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">关注我们</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="小红书">
                <span className="text-sm font-bold">红</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            &copy; 2026 爱情岛论坛亚洲. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}